import { ServiceRequestStatus } from "../constants";
import { isUndefined } from "./validators";

export const isSuccessStatusCode = (statusCode: number) => statusCode >= 200 && statusCode < 400;

export const getRequestStatus = (statusCode: number | undefined): ServiceRequestStatus => {
  let requestStatus: ServiceRequestStatus = ServiceRequestStatus.Undefined;
  if (isUndefined(statusCode)) {
    requestStatus = ServiceRequestStatus.Unknown;
  } else if (statusCode === 0) {
    requestStatus = ServiceRequestStatus.TransportError;
  } else if (statusCode >= 100 && statusCode < 200) {
    requestStatus = ServiceRequestStatus.Other;
  } else if (statusCode >= 200 && statusCode < 400) {
    requestStatus = ServiceRequestStatus.Success;
  } else if (statusCode >= 400 && statusCode < 500) {
    requestStatus = ServiceRequestStatus.CallerError;
  } else if (statusCode >= 500) {
    requestStatus = ServiceRequestStatus.ServiceError;
  } else {
    requestStatus = ServiceRequestStatus.Unknown;
  }

  return requestStatus;
};
